import { Link } from 'react-router-dom';
import { useCart } from '../../hooks/useCart';

interface ProductCardProps {
  id: string;
  title: string;
  price: number;
  image: string;
  description?: string;
}

export default function ProductCard({ id, title, price, image, description }: ProductCardProps) {
  const { addToCart } = useCart();

  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart({
      id,
      title,
      price,
      image
    });
  };

  return (
    <Link to={`/product/${id}`} className="block">
      <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300 cursor-pointer">
        <div className="aspect-video bg-gray-700 overflow-hidden">
          <img 
            src={image}
            alt={title}
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="p-4">
          <h3 className="text-white font-semibold text-sm mb-2 line-clamp-2 h-10">{title}</h3>
          {description && (
            <p className="text-gray-400 text-xs mb-3 line-clamp-2">{description}</p>
          )}
          <div className="flex items-center justify-between">
            <span className="text-yellow-400 font-bold text-lg">€{price}</span>
            <button 
              onClick={handleAddToCart}
              className="font-semibold rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap bg-yellow-400 hover:bg-yellow-500 text-black px-3 py-1.5 text-sm"
            >
              <i className="ri-shopping-cart-line mr-1"></i>
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
}
